import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, CardHeader } from '@material-ui/core';
import { get } from 'lodash';

import { auth, emailSigninRedir } from '../state/user';
import { colors } from '../lib/styles';


const styles = {
  container: {
    backgroundAttachment: 'scroll',
    backgroundRepeat: 'repeat',
    height: '100%',
    minHeight: '900px',
    padding: '10px',
  },
  loginBox: {
    margin: '0 auto 100px',
    textAlign: 'center',
    width: '500px',
  },
  errorText: {
    color: colors.secondaryAccent,
    height: '18px',
    paddingTop: '18px',
  },
  loginBrand: {
    height: '18px',
    width: '18px',
    marginRight: '15px'
  },
  loginBrandText: {
    fontSize: '1.2em',
    width: '100%',
    textTransform: 'none',
    textAlign: 'left'
  }
};

class FirebaseEmailRedir extends Component {
  componentDidMount() {
    this.props.emailSigninRedir()
      .then((result) => {
        console.log('result in comp', result);
        this.props.router.push('/app');
      });
  }

  render() {
    const { user } = this.props;
    let errorMsg = '';
    if (user.emailSigninRedirError) {
      // eslint-disable-next-line
      errorMsg = get(user.emailSigninRedirError, 'content.message') || get(user.emailSigninRedirError, 'content.error') || user.emailSigninRedirError.message;
    }
    return (
      <div style={styles.container} >
        <Card style={styles.loginBox}>
          <CardHeader title="Signing in..." />
          <div style={styles.errorText}>{errorMsg}</div>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state;
  return { user };
}

export default connect(mapStateToProps, { auth, emailSigninRedir })(FirebaseEmailRedir);
